import { Injectable } from '@angular/core';

import {Machine} from '../models/machine';
import {ToastsManager} from 'ng2-toastr/ng2-toastr';
import {HttpService} from "./http.service";
import {User} from "../models/user";
import {PrizeSlot} from '../models/prize-slot';
import {HubModule} from "../models/hub-module";
import {UserService} from "./user.service";
import {AccountService} from "./account.service";
import { environment } from '../../environments/environment';
import { HistorySearchResult } from '../models/history-search-result';

const MAX_MODULES_BY_TYPE = 2;

@Injectable()
export class MachineService {
    constructor(
        private httpService: HttpService,
        private toastr: ToastsManager,
        private userService: UserService,
        private accountService: AccountService,
    ) {}



  getMachinesByRole(accountRole, userId): Promise<Machine[]> {
    if (this.userService.isSuper) {
        return this.accountService.getAccounts()
        .then(accounts => {
            return this.list().then(machines => {
                return machines;
            })
        })
    } else if (accountRole == 'accountAdmin') {
        return this.accountService.machines().then(machines => {
            return machines;
        });
    } else {
        return this.userService.getAssignedMachines(userId).then(machines => {
            return machines;
        })
    }
  }

  list(): Promise<Machine[]> {
    let me = this;
    let url: string = '/Machines';
    return this.httpService.get(url, { 'filter[include][hubModules]': 'slots' })
      .then(function (results:any) {
        let machines:Machine[] = [];
        for (let result of results) {
            var machine: Machine = new Machine().fromJson(result);
            machines.push(machine);
        }
        return machines;
      })
      .catch(function (error:any) {
          me.httpService.handleError(error, "Unable to retrieve machine details")
      })
  }

  get(id: any): Promise<Machine> {
    let me = this;
    let params = {

    };
    let url: string = `/Machines/${id}`;
    return this.httpService.get(url, params)
      .then(function (result:any) {
        let machine:Machine = new Machine().fromJson(result);
        return machine
      })
      .catch(function (error:any) {
        me.httpService.handleError(error, "Unable to retrieve machine details")
      })
  }

  getAssignedUsers(id: string): Promise<User[]> {
      let me = this;
      let params = {

      };
      let url: string = `/Machines/${id}/assignedUsers?filter={"include": ["user"]}`;
      return this.httpService.get(url, params)
          .then(function (result:any) {
              return result
          })
          .catch(function (error:any) {
              me.httpService.handleError(error, "Unable to retrieve machine details")
          })
  }

  getPrizes(id: any): Promise<PrizeSlot[]> {
      let me = this;
      let params = {

      };
      let url: string = `/HubModules/${id}/slots`;
      return this.httpService.get(url, params)
          .then(function (result:any) {
              return new PrizeSlot().fromJsonArray(result);
          })
          .catch(function (error:any) {
              me.httpService.handleError(error, "Unable to retrieve slot details")
          })
  }

  updateSlotAttribute(id: any, data: any): Promise<PrizeSlot> {
      let me = this;
      let url: string = `/MachineSlots/${id}`;
      return this.httpService.patch(url, data)
          .then(function (result:any) {
              return new PrizeSlot().fromJson(result);
          })
          .catch(function (error:any) {
              me.httpService.handleError(error, "Unable to update prize slot")
          })
  }

  getHubModules(id: any): Promise<HubModule[]> {
      let me = this;
      let params = {

      };
      let url: string = `/Machines/${id}/hubModules`;
      return this.httpService.get(url, params)
          .then(function (result:any) {
              return new HubModule().fromJsonArray(result);
          })
          .catch(function (error:any) {
              me.httpService.handleError(error, "Unable to retrieve hub modules")
          })
  }

  getHistoryActivity(id: string, startDate: Date, endDate: Date, page: Number, sortDir: string = 'DESC'): Promise<HistorySearchResult> {
      let me = this;
      let url: string = `/Machines/${id}/history`;
      let params = { startDate, endDate, page, sortDir };
      return this.httpService.get(url, params)
        .then(function (result: any) {
            return HistorySearchResult.fromJson(result);
        })
        .catch(function(error: any) {
            me.httpService.handleError(error, "Unable to retrieve machine activity");
        });
  }

    update(machine: Machine): Promise<any> {
        let me = this;
        return this.httpService.put(`/Machines/${machine.id}`, machine)
            .then(function(result: any){
                me.toastr.success("Machine Updated Successfully");
                return result;
            })
            .catch(function(error: any) {
                me.httpService.handleError(error, "Unable to Update Machine")
            })
    }

    restock(id: any): Promise<any> {
        let me = this;
        let params = {

        };
        let url: string = `/Machines/${id}/slots/restock`;
        return this.httpService.post(url, params)
            .then(function (result:any) {
                return result
            })
            .catch(function (error:any) {
                me.httpService.handleError(error, "Unable to retrieve machine details")
            })
    }

    saveSlot(slot: PrizeSlot): Promise<PrizeSlot> {
        let me = this;
        let url: string = `/MachineSlots/${slot.id}`;
        return this.httpService.put(url, slot)
            .then(function (result:any) {
              return new PrizeSlot().fromJson(result);
            })
            .catch(function (error:any) {
              me.httpService.handleError(error, "Unable to save slot")

            })
    }

    getSlotImages(): Promise<any> {
        let me = this;
        let params = {};
        let url: string = `/FileStorage/${this.userService.accountBucketName}/files`;
        return this.httpService.get(url, params)
            .then(function (result:any) {
                return result.map(function(r) {
                  r.imageUrl = me.httpService.getUrl(`/FileStorage/${r.container}/download/` + encodeURIComponent(r.name));
                  return r;
                });
            })
            .catch(function (error:any) {
                me.httpService.handleError(error, "Unable to get slot images")
            })
    }

    updateSlotImage(slot: any): Promise<any> {
        let me = this;
        let url: string = `/MachineSlots/${slot.id}`;
        return this.httpService.put(url, slot)
            .then(function (result:any) {
                return result
            })
            .catch(function (error:any) {
                me.httpService.handleError(error, "Unable to save slot")
            })
    }

    updateMachineAssignment(assignment: any): Promise<any> {
        let me = this;
        return this.httpService.put(`/MachineAssignments/${assignment.id}`, assignment)
            .then(function(result: any){
                me.toastr.success("Machine Updated Successfully");
                return result;
            })
            .catch(function(error: any) {
                me.httpService.handleError(error, "Unable to Update Machine Assignment")
            })
    }

    validateCanAddModule(machine: Machine, type: string) : boolean {
        let typeCount: number = 0;
        for (let hm of machine.hubModules) {
            if (hm.type === type) {
                typeCount += 1;
            }
        }
        return typeCount < MAX_MODULES_BY_TYPE;
    }

    addModule(id, data): Promise<HubModule> {
        let me = this;
        let url: string = `/HubModules`;
        return this.httpService.post(url, data)
            .then(function (result:any) {
                return new HubModule().fromJson(result);
            })
            .catch(function (error:any) {
                me.httpService.handleError(error, "Unable to add new slot")
            })
    }

    saveHub(hub): Promise<HubModule> {
        let me = this;
        let url: string = `/HubModules/` + hub.id;
        return this.httpService.put(url, hub)
            .then(function (result:any) {
                return new HubModule().fromJson(result);
            })
            .catch(function (error:any) {
                me.httpService.handleError(error, "Unable to disable hub module")
            })
    }

    addMachine(machine): Promise<Machine> {
        let me = this;
        let url: string = `/Machines`;
        machine.status = "normal";
        machine.accountId = this.userService.accountId;
        return this.httpService.post(url, machine)
            .then(function (result:any) {
                return new Machine().fromJson(result);
            })
            .catch(function (error:any) {
                me.httpService.handleError(error, "Unable to create machine")
            })
    }

    deleteSlotImage(image): Promise<any> {
      let me = this;
      let url: string = `/MachineSlots/deleteSlotImage`;
      return this.httpService.post(url, image)
      .then(function (result:any) {
        return true;
      })
      .catch(function (error:any) {
        me.httpService.handleError(error, 'Unable to delete image');
        return error;
      })
    }

    deleteMachine(machine): Promise<boolean> {
        const me = this;
        const url: string = `/Machines/${machine.id}`;
        return this.httpService.delete(url)
        .then(function (result:boolean) {
            return result;
        })
        .catch(function (error: any) {
            me.httpService.handleError(error, 'Unable to delete machine ' + machine.name);
            return false;
        })
    }

}



// WEBPACK FOOTER //
// ./src/app/services/machine.service.ts